export const iconFontAwesomeNatureWorm = (
	<i className="fa-solid fa-worm"></i>
);
